import PropTypes from 'prop-types'
import styled from 'styled-components'

import { PG, WHITE } from '../../colors'

const Mark = styled.mark`
  color: ${({ highlightFgColor }) => highlightFgColor};
  background-color: ${({ highlightBgColor }) => highlightBgColor};
`
/**
 * The Highlighter can be used to mark substrings of text to help them stand out.
 */
const Highlighter = ({ text, mark, highlightFgColor = WHITE, highlightBgColor = PG }) => {
  if (text && mark) {
    const textStr = text.toString()
    const escapedMark = mark.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&')
    const regex = new RegExp(`(${escapedMark})`, 'gi')
    const parts = textStr.split(regex)

    if (parts.length > 1) {
      return (
        <span>
          {parts.map((part, idx) => {
            const key = `${part}-${idx}`

            if (!part) {
              // Happens when the entire text matches the mark
              return null
            }

            if (regex.test(part)) {
              return (
                <Mark
                  key={key}
                  highlightFgColor={highlightFgColor}
                  highlightBgColor={highlightBgColor}>
                  {part}
                </Mark>
              )
            }

            return <span key={key}>{part}</span>
          })}
        </span>
      )
    }
  }

  return text
}

Highlighter.propTypes = {
  /** The text to search for a mark */
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** The background color of the highlighter */
  highlightBgColor: PropTypes.string,
  /** The foreground color of the highlighter */
  highlightFgColor: PropTypes.string,
  /** The specific characters to mark within the text */
  mark: PropTypes.string
}

export { Highlighter }
